import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Card, Typography } from '@altermaind/web/ui';
import { useRecognition } from '@/conversations/state';
import { Controls } from '../Controls';
import { WrapperConversation } from '../WrapperConversation';

type Props = {
  setCurrentStep: (step: number) => void;
};

export const TestControls: FC<Props> = ({ setCurrentStep }) => {
  const t = useTranslations('conversations.testControls');

  const goToNextStep = () => {
    setCurrentStep(2);
  };

  const {
    videoRef,
    isCameraOn,
    startRecognition,
    stopRecognition,
    speaking,
    setEndCall,
    setIsCameraOn,
    handleVideoClick,
    streamRef,
  } = useRecognition();

  return (
    <WrapperConversation>
      <Box
        pt='l'
        px='huge'
        display='flex'
        justifyContent='center'
        alignItems='center'
        height='100%'
      >
        <Box flex='1' textAlign='center'>
          <Typography variant='special' mb='s'>
            {t('title')}
          </Typography>
          <Card
            height='400px'
            p='none'
            display='flex'
            alignItems='center'
            justifyContent='center'
            position='relative'
            ml='m'
            textAlign='center'
            maxWidth='800px'
            style={{ margin: '0 auto' }}
          >
            {isCameraOn && (
              <video
                ref={videoRef}
                autoPlay
                muted
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  position: 'absolute',
                  bottom: '0px',
                  left: '0px',
                  zIndex: 1000,
                  transform: 'scaleX(-1)',
                }}
              />
            )}
            <Box
              position='absolute'
              top='50%'
              left='0'
              right='0'
              style={{ transform: 'translateY(-50%)' }}
            >
              <Box maxWidth='400px' style={{ margin: '0 auto' }}>
                <Typography variant='p2/light' mb='s'>
                  {t('instructions')}
                </Typography>
              </Box>
            </Box>
            <Box zIndex={1000} position='absolute' right='xl'>
              <Controls
                startRecognition={startRecognition}
                stopRecognition={stopRecognition}
                setEndCall={setEndCall}
                speaking={speaking}
                setIsCameraOn={setIsCameraOn}
                handleVideoClick={handleVideoClick}
                isCameraOn={isCameraOn}
                streamRef={streamRef}
              />
            </Box>
          </Card>
          <Button
            style={{ margin: '0 auto' }}
            mb='xxl'
            onClick={goToNextStep}
            mt='s'
            variant='positive'
          >
            {t('cta.start')}
          </Button>
        </Box>
      </Box>
    </WrapperConversation>
  );
};
